import { companyInfo, serviceAreas } from "../data/mock";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export const Footer = () => {
  const quickLinks = [
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Tonnage Calculator", href: "#tonnage-calculator" },
  { label: "Why Choose Us", href: "#why-us" },
  { label: "Our Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#cta" }];


  const services = [
  "Split AC Installation",
  "VRF / VRV Systems",
  "Central Air Conditioning",
  "HVAC Design & Planning",
  "Annual Maintenance (AMC)",
  "Commercial HVAC Execution"];


  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-brand-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={companyInfo.logos.main}
                alt="Fix My AC - India's Premier HVAC Solutions Provider"
                className="h-14 lg:h-16 w-auto"
                loading="lazy"
                width="160"
                height="64"
              />

            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              India's trusted HVAC solutions partner — delivering excellence in VRF/VRV systems, centralized air conditioning &amp; turnkey commercial projects nationwide.
            </p>
            {/* JMD Logo */}
            <div className="bg-white/5 border border-white/10 rounded-lg p-3 mb-5 inline-flex items-center gap-3">
              <img
                src={companyInfo.logos.jmd}
                alt="J.M.D. Airconditioning Co. India - Four decades of excellence"
                className="h-8 w-auto object-contain brightness-0 invert opacity-80"
                loading="lazy"
              />

              <div>
                <p className="text-[10px] text-slate-500">A Venture of</p>
                <p className="text-xs text-slate-300 font-medium">J.M.D. Airconditioning Co.</p>
              </div>
            </div>
            <div className="space-y-3">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2.5 text-slate-400 hover:text-accent-400 text-sm transition-colors">
                <Phone className="w-4 h-4" />
                {companyInfo.phone}
              </a>
              <div className="space-y-2">
                <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2.5 text-slate-400 hover:text-accent-400 text-sm transition-colors">
                  <Mail className="w-4 h-4" />
                  <span>{companyInfo.email} <span className="text-slate-500 text-xs">(Queries)</span></span>
                </a>
                <a href={`mailto:${companyInfo.supportEmail}`} className="flex items-center gap-2.5 text-slate-400 hover:text-accent-400 text-sm transition-colors">
                  <Mail className="w-4 h-4" />
                  <span>{companyInfo.supportEmail} <span className="text-slate-500 text-xs">(Support)</span></span>
                </a>
              </div>
              <div className="flex items-center gap-2.5 text-slate-400 text-sm">
                <Clock className="w-4 h-4" />
                Mon - Sat: 9:00 AM – 7:00 PM
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-5 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) =>
              <li key={link.label}>
                  <button
                  onClick={() => scrollTo(link.href)}
                  className="text-slate-400 hover:text-accent-400 text-sm transition-colors">

                    {link.label}
                  </button>
                </li>
              )}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-5 uppercase tracking-wider">Our Services</h4>
            <ul className="space-y-2.5">
              {services.map((service) =>
              <li key={service}>
                  <button
                  onClick={() => scrollTo("#services")}
                  className="text-slate-400 hover:text-accent-400 text-sm transition-colors">

                    {service}
                  </button>
                </li>
              )}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-5 uppercase tracking-wider">
              <MapPin className="w-4 h-4 inline mr-1.5" />
              Service Areas
            </h4>
            <div className="flex flex-wrap gap-2">
              {serviceAreas.map((area) =>
              <span
                key={area}
                className="text-xs bg-brand-800 text-slate-400 px-2.5 py-1 rounded-md border border-brand-700/50">

                  {area}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* SEO Keywords Strip */}
      <div className="border-t border-brand-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-[11px] text-brand-700 text-center leading-relaxed">
            HVAC Contractor India • AC Installation Services • VRF System Installation • Central Air Conditioning Solutions • Commercial HVAC Services • HVAC AMC Services
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-brand-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-slate-500 text-xs">
              © {new Date().getFullYear()} {companyInfo.name}. All rights reserved. {companyInfo.ventureOf}
            </p>
            <div className="flex items-center gap-4">
              <button className="text-slate-500 hover:text-slate-300 text-xs transition-colors">Privacy Policy</button>
              <button className="text-slate-500 hover:text-slate-300 text-xs transition-colors">Terms of Service</button>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};